export const getProductUrl = (id: string, slug: string): string => {
  return `/product/${id}/${slug}/`;
};
